<template>
  <div class="switch">
    <el-switch v-model="istime" active-color="#67C23A" :class="istime ? 'active' : 'inactive'" @change="toggleSwitch">
    </el-switch>
    <div class="txt">结款提醒</div>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number]
  },
  data() {
    return {
      istime: this.value == 1,
    };
  },
  watch: {
    value: {
      deep: true,
      handler(newVal) {
        // console.log('form changed', { ...newVal })
        this.istime = (newVal == 1)
      },
    },
  },
  methods: {
    toggleSwitch() {
      this.$emit('onToggle', this.istime)
    },
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.switch {
  margin-left: 10px;
  position: absolute;
  right: -60px;

  .el-switch {
    display: block;

    .el-switch__core {
      margin: 2px auto;
      display: block;
    }

    &.inactive {
      .el-switch__core::after {
        content: '关';
        line-height: 17px;
        text-indent: 18px;
        color: #fff;
      }
    }

    &.active {
      .el-switch__core::after {
        content: '开';
        line-height: 17px;
        text-indent: -16px;
        color: #fff;
      }
    }
  }

  .txt {
    min-width: 50px;
    line-height: 16px;
    font-size: 12px;
    color: #909399;
    margin-top: 3px;
  }
}
</style>
